/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ESSOCategory } from "../types/ESSOCategory.ts";

/**
 * @description 1 = Agribusiness | 2 = DataTech | 3 = Finance | 4 = Education | 5 = MarketingAndSales | 6 = Business | 7 = Law | 8 = HumanResources | 9 = ProjectManagement | 10 = General |
 */
export const ESSOCategorySchema = z
  .union([
    z.literal(1),
    z.literal(2),
    z.literal(3),
    z.literal(4),
    z.literal(5),
    z.literal(6),
    z.literal(7),
    z.literal(8),
    z.literal(9),
    z.literal(10),
  ])
  .describe(
    "1 = Agribusiness | 2 = DataTech | 3 = Finance | 4 = Education | 5 = MarketingAndSales | 6 = Business | 7 = Law | 8 = HumanResources | 9 = ProjectManagement | 10 = General | ",
  ) as unknown as ToZod<ESSOCategory>;
